import "@/App.css";
import { useRef, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./AuthContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Products from "./components/Products";
import Gallery from "./components/Gallery";
import SidePieces from "./components/SidePieces";
import OrderForm from "./components/OrderForm";
import Footer from "./components/Footer";
import Login from "./Login";
import OrdersInbox from "./OrdersInbox";

const Landing = () => {
  const orderRef = useRef(null);
  const [preselected, setPreselected] = useState("");

  const scrollToOrder = (item = "") => {
    setPreselected(item);
    orderRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="min-h-screen bg-[#F9F6F0]">
      <Header onOrder={() => scrollToOrder()} />
      <main>
        <Hero onOrder={() => scrollToOrder()} />
        <Marquee />
        <Products onOrder={scrollToOrder} />
        <Gallery />
        <SidePieces />
        <div ref={orderRef}>
          <OrderForm preselected={preselected} />
        </div>
      </main>
      <Footer />
    </div>
  );
};

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-[#F9F6F0] flex items-center justify-center" data-testid="auth-loading">
        <p className="font-hand text-2xl text-[#A67C52]">untangling yarn…</p>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, wheelMultiplier: 0.95 }}>
      <AuthProvider>
        <Toaster position="bottom-center" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin/orders"
              element={
                <ProtectedRoute>
                  <OrdersInbox />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ReactLenis>
  );
}

export default App;
